import { Injectable } from '@angular/core';

import { IAddToEventDialogConfig, IAddToEventDialogResult } from './interfaces';
import { AppDomService } from './app-dom.service';
import { ValidatorService } from './shared/validator.service';

@Injectable({
    providedIn: 'root'
})
export class AddToEventModalDialogService {
    private readonly selectors = {
        modalDialogOverlay: '[aza-rws-modal-dialog-overlay]',
        modalDialog: '[aza-rws-add-to-event-dialog]',
        cancelButton: '[aza-rws-modal-dialog-first-button]',
        proceedButton: '[aza-rws-modal-dialog-second-button]',
        email: '[aza-rws-add-to-event-email-input]',
        emailValidationError: '[aza-rws-add-to-event-email-input-field-validation-error]',
    };

    constructor(
        private readonly appDomSvc: AppDomService,
        private readonly validatorSvc: ValidatorService,
    ) { }

    async showPopupDialog(config: IAddToEventDialogConfig): Promise<IAddToEventDialogResult> {
        const modalDialogOverlayEl = document.querySelector(this.selectors.modalDialogOverlay);
        const modalDialogEl = document.querySelector(this.selectors.modalDialog);
        this.appDomSvc.showElementWithCss(modalDialogOverlayEl);
        this.appDomSvc.showElementWithCss(modalDialogEl);
        const proceedBtnEl = modalDialogEl.querySelector(this.selectors.proceedButton) as HTMLButtonElement;
        const fieldValidationError = modalDialogEl.querySelector(this.selectors.emailValidationError) as HTMLDivElement;
        const emailEl = modalDialogEl.querySelector(this.selectors.email) as HTMLInputElement;
        emailEl.oninput = ev => {
            const emailValue = this.getInputFieldTrimmedTextValue(ev.target as HTMLInputElement);
            let isEmailValid = true;
            let emailValidationErrorText = '';
            if (emailValue.trim()) {
                emailValidationErrorText = this.validatorSvc.getEmailValidationErrorText(emailValue);
                isEmailValid = !emailValidationErrorText;
            }
            proceedBtnEl.disabled = !isEmailValid;
            if (!isEmailValid) {
                fieldValidationError.innerText = emailValidationErrorText;
            } else {
                fieldValidationError.innerText = '';
            }
        };
        const promise = new Promise<IAddToEventDialogResult>((resolve, reject) => {
            const cancelBtnEl = modalDialogEl.querySelector(this.selectors.cancelButton) as HTMLDivElement;
            cancelBtnEl.onclick = () => resolve(null);
            proceedBtnEl.onclick = () => {
                resolve({
                    email: this.getInputFieldTrimmedTextValue(emailEl),
                });
            };
        });
        return promise;
    }

    hidePopupDialog(): void {
        const modalDialogOverlayEl = document.querySelector(this.selectors.modalDialogOverlay);
        const modalDialogEl = document.querySelector(this.selectors.modalDialog);
        this.appDomSvc.hideElementWithCss(modalDialogOverlayEl);
        this.appDomSvc.hideElementWithCss(modalDialogEl);
        const emailEl = modalDialogEl.querySelector(this.selectors.email) as HTMLInputElement;
        emailEl.value = '';
    }

    private getInputFieldTrimmedTextValue(inputEl: HTMLInputElement): string {
        return inputEl.value?.trim();
    }
}
